import { useMutation } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { useCallback, useState } from 'react';

import {
  CreateUberDeliveryDocument,
  GetReceptionPaneAppointmentDocument,
} from '~/graphql/generated/graphql';
import { requestUberDeliveryModalState } from '~/state/reception/atoms';

export const useRequestUberDelivery = () => {
  const { appointmentId, quoteId, autoMode } = useAtomValue(requestUberDeliveryModalState);
  const resetState = useResetAtom(requestUberDeliveryModalState);
  const [error, setError] = useState<string | null>(null);
  const [requestUberDelivery, { loading }] = useMutation(CreateUberDeliveryDocument, {
    refetchQueries: [{ query: GetReceptionPaneAppointmentDocument, variables: { appointmentId } }],
  });

  const create = useCallback(
    async (pieces: Array<number | ''>) => {
      setError(null);

      try {
        if (appointmentId && quoteId) {
          await requestUberDelivery({
            variables: {
              input: {
                appointmentId,
                quoteId,
                autoMode: autoMode === 'delivered' || autoMode === 'canceled',
                undeliverableReason:
                  autoMode === 'canceled' ? 'cannot_find_customer_address' : null,
                quantities: pieces.filter((v) => v !== null) as number[],
              },
            },
          });
          resetState();
        }
      } catch (e) {
        const message = e?.message || 'エラーが発生しました';
        setError(message);
      }
    },
    [appointmentId, quoteId, requestUberDelivery, autoMode, resetState],
  );

  const resetError = useCallback(() => {
    setError(null);
  }, []);

  return { create, loading, error, resetError };
};
